import { KeyboardArrowDown } from "@mui/icons-material";
import { MenuItem, Select, styled } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useState } from "react";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

const RETAILSTAT_URL = process.env.REACT_APP_RETAILSTAT_URL ?? "";

const products = [
    { name: "POI Data", url: "https://aggdata.com" },
    {
        name: "Financial Health Insights",
        url: `${RETAILSTAT_URL}/api/services/cnt?relayState=sso-cnt`,
    },
    {
        name: "Accounts Receivable Management Solutions",
        url: `${RETAILSTAT_URL}/api/services/arms?relayState=`,
    },
    {
        name: "Retail Openings & Closings",
        url: `${RETAILSTAT_URL}/api/services/roc?relayState=sso-roc`,
    },
    {
        name: "Grocery Insights",
        url: "https://insights.mtnra.com",
    },
];

const ProductDropdown = ({ className }: IWithClassName) => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleProductChange = (event: SelectChangeEvent) => {
        const selectedValue = event.target.value;
        const product = products.find(
            (product) => product.name === selectedValue,
        );
        if (product?.url) {
            window.open(product.url, "_blank");
        }
    };

    return (
        <div
            className={
                menuOpen ? `${className ?? ""} menu-open` : (className ?? "")
            }
        >
            <Select
                MenuProps={{
                    PaperProps: { className: "dropdown-menu" },
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                }}
                IconComponent={KeyboardArrowDown}
                onOpen={() => setMenuOpen(true)}
                onClose={() => setMenuOpen(false)}
                displayEmpty={true}
                onChange={handleProductChange}
                value={products[0].name}
            >
                {products.map((product) => (
                    <MenuItem key={product.name} value={product.name}>
                        {product.name}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
};

export default styled(ProductDropdown)(({ theme }: IWithThemeProps) => ({
    marginTop: theme?.spacing(6),
    paddingRight: theme?.spacing(7.5),
    ".MuiSelect-select": {
        paddingTop: theme?.spacing(1),
        paddingBottom: theme?.spacing(1),
        paddingLeft: theme?.spacing(2),
        color: theme?.palette.dropdown.textColor,
        fontWeight: 600,
    },
    "&.menu-open .MuiSelect-select": {
        backgroundColor: theme?.palette.dropdown.selectColor,
    },
    ".MuiSelect-outlined": {
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
        border: "none",
        borderRadius: "0px",
    },
    ".MuiOutlinedInput-notchedOutline": { border: "none" },
}));
